import script from "./ComAnalysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComAnalysis.vue?vue&type=script&setup=true&lang=ts"

import "./ComAnalysis.vue?vue&type=style&index=0&id=6d48b976&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d48b976"]])

export default __exports__